import { render, staticRenderFns } from "./SDKVersion.vue?vue&type=template&id=57ccee13&scoped=true&"
import script from "./SDKVersion.vue?vue&type=script&lang=js&"
export * from "./SDKVersion.vue?vue&type=script&lang=js&"
import style0 from "./SDKVersion.vue?vue&type=style&index=0&id=57ccee13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ccee13",
  null
  
)

export default component.exports